import { createElement } from '@max/max';
import View from '@hfe/max-view';
import ScrollView from '@hfe/max-scrollview';
import { STYLE_TYPE, SHOW_TYPE } from '../../types/fe';
import { RENDER_CONFIG_MAP } from './types';
import { LoadingMore } from './loading-more';
import './index.scss';
// 获取渲染配置
export function getRenderConfig(styleType, showType) {
    const key = styleType === STYLE_TYPE.COMPREHENSIVE_CARD ? `${styleType}` : `${styleType}_${showType}`;
    return RENDER_CONFIG_MAP[key] || RENDER_CONFIG_MAP[`${STYLE_TYPE.COMMON}_${SHOW_TYPE.VERTICAL_DOUBLE}`];
}
// 渲染列表项
export function renderListItems(props, config) {
    var _a;
    const { vo, feConfig, onCardClick, onCardShow, ChildComponent } = props;
    return (_a = vo === null || vo === void 0 ? void 0 : vo.list) === null || _a === void 0 ? void 0 : _a.map((voItem, index) => <View className={config.className} key={voItem.id} style={config.styleType === STYLE_TYPE.COMPREHENSIVE_CARD || config.showType === SHOW_TYPE.VERTICAL_DOUBLE ? {
        marginBottom: "16rpx"
    } : {
        marginRight: "16rpx"
    }}>
      <ChildComponent key={voItem.id} vo={voItem} feConfig={feConfig} index={index} onCardClick={onCardClick} onCardShow={onCardShow}/>
    </View>);
}
// 渲染加载更多组件
export function renderLoadingMore(props, config) {
    const { loadMoreStatus, loadMoreType, onLoadMore, isLastPage, styleOptions } = props;
    const showType = config.styleType === STYLE_TYPE.COMPREHENSIVE_CARD ? SHOW_TYPE.VERTICAL_DOUBLE : config.showType;
    return <LoadingMore loadMoreStatus={loadMoreStatus} loadMoreType={loadMoreType} onLoadMore={onLoadMore} showType={showType} isLastPage={isLastPage} loadMoreTextColor={styleOptions.loadMoreTextColor}/>;
}
// 渲染列表容器
export function renderListContainer(props, config) {
    const listItems = renderListItems(props, config);
    const loadingMore = renderLoadingMore(props, config);
    // 水平滚动容器
    if (config.showType === SHOW_TYPE.HORIZONTAL) {
        return <View className="list-container--success-horizontal">
        <ScrollView {...config.containerProps}>
          {listItems}
          {loadingMore}
          <View></View>
        </ScrollView>
      </View>;
    }
    // 垂直容器
    const containerClassName = config.styleType === STYLE_TYPE.COMPREHENSIVE_CARD ? '' : 'list-container--success-vertical';
    return <View className={containerClassName}>
      {listItems}
      {loadingMore}
    </View>;
}
